import {
    getPageInfo,
    getUserInfo,
} from "@services/tracking/trackers/pageImpressionTracker";
import TrackingService from "@services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import {
    StepVariables,
    ToolContext,
    ToolContextTrackingInfo,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

const trackRegistrationToolStep = (
    eventName: string,
    step: StepVariables,
    context: ToolContext,
): void => {
    const event: TypedAnalyticsEvent<ToolContextTrackingInfo> = {
        event: eventName,
        payload: {
            eventData: {
                ...step,
                ...context,
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackRegistrationToolStep };
